import {
  STORE_USER_DATA,
  CLEAR_USER_DATA,
  UPDATE_USER_CLAIMS,
  STORE_PROJECTS_ROLES,
  STORE_IS_SUPER_ADMIN,
  STORE_USER_SETTINGS,
  ASYNC_SUCCESS,
  STORE_COMPANIES_ROLES
} from '../actions'

const user = (state = null, { type, payload }) => {
  switch (type) {
    case STORE_USER_DATA:
      const claims = JSON.parse(atob(payload.idToken.split('.')[1]))
      const { idToken } = payload

      return {
        data: payload.user,
        claims,
        idToken
      }

    case CLEAR_USER_DATA:
      return null

    case UPDATE_USER_CLAIMS: {
      const claims = JSON.parse(atob(payload.idToken.split('.')[1]))
      const { idToken } = payload

      return {
        ...state,
        claims,
        idToken
      }
    }

    case STORE_PROJECTS_ROLES: {
      const { projectsRoles } = payload

      return {
        ...state,
        projectsRoles
      }
    }

    case STORE_COMPANIES_ROLES: {
      const { companiesRoles } = payload

      return {
        ...state,
        companiesRoles
      }
    }

    case STORE_IS_SUPER_ADMIN: {
      const { isSuperAdmin } = payload

      return {
        ...state,
        isSuperAdmin
      }
    }

    case STORE_USER_SETTINGS: {
      const { settings } = payload
      return {
        ...state,
        settings
      }
    }

    case ASYNC_SUCCESS: {
      switch (payload.actionName) {
        case 'updateUserSettings': {
          return {
            ...state,
            settings: payload.userSettings
          }
        }

        case 'createProject': {
          // save my Project role (super admin) to Redux
          return {
            ...state,
            projectsRoles: {
              ...state.projectsRoles,
              [payload.projectId]: 0
            }
          }
        }

        default:
          return state
      }
    }

    default:
      return state
  }
}

export default user



// WEBPACK FOOTER //
// ./src/reducers/user.js